import React, { FunctionComponent } from 'react';
import { ViewICon } from 'app/assets/images/icons';
import styles from './ManualGrabbingFormHeader.module.scss';
import CardTitle from 'app/components/CardTitle';
import Loader from 'app/components/Loader';

interface Props {
  title: string;
  handleClick: any;
  disabled: boolean | undefined;
  eyeValidate?: boolean;
  compId: string;
  hideIcon?: boolean;
  isOpenPopup?: boolean;
}

const ManualGrabbingFormHeader: FunctionComponent<Props> = ({
  title,
  handleClick,
  disabled,
  eyeValidate,
  compId,
  hideIcon,
  isOpenPopup,
}) => {
  return (
    <div className={styles.ManualGrabbingFormHeader}>
      <div data-testid="title-testid">
        <CardTitle title={title} compId={compId} hideIcon={hideIcon} />
      </div>
      {disabled && isOpenPopup ? (
        <div
          style={{
            position: 'relative',
            top: '0px',
            width: '20px',
            height: '20px',
          }}
        >
          <Loader mediumSize />
        </div>
      ) : (
        <button
          className="unstyled-button"
          disabled={!isOpenPopup && disabled}
          type="button"
          onClick={() => handleClick(isOpenPopup, isOpenPopup)}
          data-testid="viewIcon-testid"
          data-error={eyeValidate}
        >
          <ViewICon />
        </button>
      )}
    </div>
  );
};

export default ManualGrabbingFormHeader;
